import { DataTableCol } from "../../../components/tables/types";

export const RegisterDataGridCols: DataTableCol[] = [
  {
    title: "Select",
    control: "select", // special control for checkbox
    sortable: false,
    canShowColumn: true,
    isCheckbox: true, // custom property to mark as checkbox
  },
  {
    title: "Date",
    control: "createdAt",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Name",
    control: "name",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Email",
    control: "emailAddress",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Phone Number",
    control: "contactNumber",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Domain Of Interest",
    control: "domainOfInterest",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "College",
    control: "collegeName",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Degree Year",
    control: "degreeYear",
    sortable: true,
    canShowColumn: true,
  },
  {
    title: "Active",
    control: "prospectlist",
    sortable: true,
    canShowColumn: true,
  },
  // {
  //     title: 'Actions',
  //     control: 'both',
  //     sortable: false,
  //     isEdit: true,
  //     isDelete: true,
  //     canShowColumn: true
  // },
];
